/**
 * The app's product name, in one place.
 *
 * `dstretch` is the name of the *algorithm* this app applies — decorrelation
 * stretch — and of the project that implements it. It is not the name of the
 * app. Anything a visitor reads comes from this module, so renaming the product
 * is a change to one string here plus the `<title>` fallbacks in `web/*.html`
 * (which name the page, not the app).
 *
 * @module web/js/brand
 */

/** The product name. */
export const APP_NAME = 'Ochre';

/** Lowercase form, for file names and storage keys. */
export const APP_SLUG = 'ochre';

/** The line under the name in the header. */
export const APP_TAGLINE = 'decorrelation stretch for rock-art photographs';

/** The `<title>` for a page: the page word first, the app name last. */
export function pageTitle(page: string): string {
  return `${page} — ${APP_NAME}`;
}

/** Put the app name in the document title of the page that is running. */
export function titleFor(page: string): void {
  document.title = pageTitle(page);
}
